var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip-group',{attrs:{"multiple":"","column":"","active-class":"primary"},model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}},_vm._l((_vm.tags),function(tag){return _c('v-chip',{key:tag,staticClass:"tag-chip"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(tag))+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }